import {
	ChangeDetectorRef,
	Component,
	OnInit,
	ViewChild,
	Input,
	AfterViewInit,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { decrypt } from "../../../../../../../app/utilities/utilityFunctions";
import { HecResponse } from "../../../../../../../app/shared/shared-interfaces/hecResponse";
import { CommonHelper } from "../../../../../../../app/utilities/common.helper";
import { PucaUndertakingModel } from "./Model/puca-undertaking.model";
import { PucaUndertakingService } from "./Service/puca-undertaking.service";
import { Router } from "@angular/router";
import { PucaDataService } from "../../../services/puca-data.service";
import { PucaFormService } from "../puca-form.service";
import { SharedService } from "../../../../../../../../src/app/shared/sharedServices/shared.service";
import { WarningModalComponent } from "../../../../../../../../src/app/shared/shared-components/modal/warning-modal/warning-modal.component";
import { MatDialog } from "@angular/material";
import { LoaderService } from "../../../../../../shared/sharedServices/loader.service";

@Component({
	selector: "kt-puca-undertaking",
	templateUrl: "./puca-undertaking.component.html",
	styleUrls: ["./puca-undertaking.component.scss"],
})
export class PucaUndertakingComponent implements OnInit, AfterViewInit {
	@ViewChild("undertakingForm", { static: false }) undertakingForm: NgForm;
	public undertakingModel: PucaUndertakingModel = new PucaUndertakingModel();
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public isAlertVisible: boolean = false;
	@Input() pucaApplication: any;
	@Input("formType") formType: string;
	@Input() isAdmin: boolean = false;
	profile: any;
	loginDetails: any;
	fatherName: any;
	constructor(
		private pucaUndertakingService: PucaUndertakingService,
		private matDialog: MatDialog,
		private pucaFormService: PucaFormService,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private pucaDataService: PucaDataService,
		private sharedServices: SharedService,
		private loaderService: LoaderService,
	) {
		this.pucaFormService.setNewPucaApplication.subscribe((v) => {
			this.pucaApplication = v;
			if (this.pucaApplication) {
				// this.undertakingModel.ResearchProposal =
				// 	this.pucaApplication.pucaApplicationDto.studyResearchObjectives;
				// this.undertakingModel.StatementOfPurpose =
					// this.pucaApplication.pucaApplicationDto.personalStatement;
				this.undertakingModel.UndertakingAccepted =
					this.pucaApplication.pucaApplicationDto.isUndertaking;
				this.undertakingModel.shareInfo = this.pucaApplication
					.pucaApplicationDto.isShareDetails
					? "1"
					: "2";
				this.undertakingModel.hasDisability = this.pucaApplication
					.pucaApplicationDto.isPhysicalImpairment
					? "1"
					: "2";
				this.undertakingModel.disabilityDetails =
					this.pucaApplication.pucaApplicationDto.physicalImpairmentDetails;
			}
		});
	}

	ngAfterViewInit(): void {
		if (this.pucaApplication) {
			// this.undertakingModel.ResearchProposal =
			// 	this.pucaApplication.pucaApplicationDto.studyResearchObjectives;
			// this.undertakingModel.StatementOfPurpose =
				// this.pucaApplication.pucaApplicationDto.personalStatement;
			this.undertakingModel.UndertakingAccepted =
				this.pucaApplication.pucaApplicationDto.isUndertaking;
			this.undertakingModel.shareInfo = this.pucaApplication
				.pucaApplicationDto.isShareDetails
				? "1"
				: "2";
			this.undertakingModel.hasDisability = this.pucaApplication
				.pucaApplicationDto.isPhysicalImpairment
				? "1"
				: "2";
			this.undertakingModel.disabilityDetails =
				this.pucaApplication.pucaApplicationDto.physicalImpairmentDetails;

			this.profile = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);
			this.loginDetails = JSON.parse(
				decrypt(localStorage.getItem("loginDetails"))
			);
			this.getProfileFormData();
		}
	}

	ngOnInit() {}

	private async getProfileFormData() {
		const res: any = await this.sharedServices
			.getEmploymentInfoDetails()
			.toPromise();
		this.fatherName = res.data.profileDto.personalDetail.fatherName;
	}

	rpChanged = (e) => {
		this.undertakingModel.rpText = `'Characters Remaining: '${
			2000 - e.length
		}`;
		// this.undertakingModel.ResearchProposal =
		// 	this.undertakingForm.value.ResearchProposal;
	};

	sopChanged = (e) => {
		this.undertakingModel.sopText = `'Characters Remaining: '${
			2000 - e.length
		}`;
		// this.undertakingModel.StatementOfPurpose =
		// 	this.undertakingForm.value.StatementOfPurpose;
	};

	setHasDisability = (v) => (this.undertakingModel.hasDisability = v);

	setShareInfo = (v) => (this.undertakingModel.shareInfo = v);

	async submitMessage() {
		this.markFormsTouched(this.undertakingForm);
		if (this.validate(this.undertakingForm)) {
			await this.ModalComponent(
				WarningModalComponent,
				"PUCA Service",
				"It is requested that the application form details must be checked as application once submitted will not be updated."
			);
		} else {
			if (this.findInvalidControls().length > 0) {
				this.alertBoxMsg(
					"Please fill all the mandatory fields with valid data"
				);
				this.isAlertVisible = true;
				this.cdr.detectChanges();
			}
		}
	}
	afterSubmissionMessage(Component, title, message, type?): any {
		const dialogRef = this.matDialog.open(Component, {
			width: "70vw",
			height: "60vh",
			backdropClass: "landingpage-popup",
			panelClass: "landingpage-popup-inner",
			disableClose: true,
			autoFocus: false,
			data: { title: title, message: message },
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (type != "cancel") {
				if (result) {
					this.router.navigate(["/applicant-dashboard"]);
					this.cdr.detectChanges();
				}
			} else if (type == "cancel") {
				if (result) {
				}
			}
		});
	}
	public ModalComponent(Component, title, message, type?): any {
		const dialogRef = this.matDialog.open(Component, {
			width: "70vw",
			height: "60vh",
			backdropClass: "landingpage-popup",
			panelClass: "landingpage-popup-inner",
			disableClose: true,
			autoFocus: false,
			data: { title: title, message: message },
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (type != "cancel") {
				if (result) {
					this.submitUndertaking();
				}
			} else if (type == "cancel") {
				if (result) {
				}
			}
		});
	}
	submitUndertaking = () => {
		if (
			this.pucaDataService.isBatchActive ||
			this.pucaDataService.isInRevision ||
			this.pucaDataService.isSaveOnly ||
			this.pucaDataService.isCategory1
		) {
			const profile = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);

			this.markFormsTouched(this.undertakingForm);
			if (this.validate(this.undertakingForm)) {
				const payload: any = {
					data: {},
				};

				payload.data.id = this.pucaApplication
					? this.pucaApplication.pucaApplicationDto.id
					: 0;
				payload.data.configScholarshipId = this.pucaApplication
					? this.pucaApplication.pucaApplicationDto
							.configScholarshipId
					: 0;
				payload.data.commonProfileId = this.pucaApplication
					? this.pucaApplication.pucaApplicationDto.commonProfileId
					: profile["profileId"];
				// payload.data.studyResearchObjectives =
				// 	this.undertakingModel.ResearchProposal;
				// payload.data.personalStatement =
				// 	this.undertakingModel.StatementOfPurpose;
				payload.data.isShareDetails =
					this.undertakingModel.shareInfo === "1";
				payload.data.isUndertaking =
					this.undertakingModel.UndertakingAccepted;
				payload.data.isPhysicalImpairment =
					this.undertakingModel.hasDisability === "1";
				payload.data.physicalImpairmentDetails =
					this.undertakingModel.disabilityDetails;
				payload.data.isSubmit = true;
				
				this.loaderService.setValue(true);

				return new Promise((resolve, reject) => {
					this.pucaUndertakingService
						.saveApplication(payload)
						.subscribe(
							async (res: HecResponse) => {
								this.loaderService.setValue(false);
								if (res.code == 0) {
									resolve(res.result);
									await this.afterSubmissionMessage(
										WarningModalComponent,
										"PUCA Service",
										"Please email Downloaded Application Form along with relevant documents on the following email address: pmu@hec.gov.pk. At this stage you are not required to submit hard copies of this application and other documents. You may be asked to submit hard copies at later stage, when required."
									);

									this.cdr.detectChanges();
								} else {
									reject(null);
								}
							},
							(err) => {
								this.loaderService.setValue(false);
								reject(null);
							}
						);
				}).catch(function (error) {});
			} else {
				if (this.findInvalidControls().length > 0) {
					this.alertBoxMsg(
						"Please fill all the mandatory fields with valid data"
					);
					this.isAlertVisible = true;
					this.cdr.detectChanges();
				}
			}
		} else
			this.ModalComponent(
				WarningModalComponent,
				"PUCA SERVICE",
				"You cannot apply for this scholarship because scholarship end date has already passed."
			);
	};

	markFormsTouched = (form) => CommonHelper.markFormGroupTouched(form);

	validate = (f) => {
		if (f.status === "VALID") {
			return true;
		}
	};

	findInvalidControls = () => {
		const invalid = [];
		const controls = this.undertakingForm.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	};

	alertBoxMsg = (message, alertType?) => {
		if (alertType == "success") {
			this.alertClass =
				"alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fa fa-check-circle";
		} else if (alertType == "warning") {
			this.alertClass =
				"alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fas fa-exclamation-circle";
		} else {
			this.alertClass =
				"alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fa fa-exclamation-triangle";
		}
		this.alertMsgValue = message;
	};

	public goBack() {
		this.pucaFormService.previousStep.next(true);
		this.cdr.detectChanges();
	}

	public cancelAttestaion() {
		if (this.isAdmin) {
			this.router.navigate(["/admin-dashboard/PAK-US-Admnin-Dashboard"]);
		} else {
			this.router.navigate(["/"]);
		}
	}

	onDisabilityValueUpdate = (e) =>
		(this.undertakingModel.disabilityDetails = e);
}
